import { useState } from "react";
import { Link, useNavigate, Navigate } from "react-router-dom";
import { Lock } from "lucide-react";
import { useAuth } from "@/context/AuthContext";
import { apiError } from "@/lib/api";
import Logo from "@/components/Logo";
import Seo from "@/components/Seo";

export default function AdminLogin() {
  const { user, loading, login } = useAuth();
  const navigate = useNavigate();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const [busy, setBusy] = useState(false);

  if (!loading && user) return <Navigate to="/admin" replace />;

  const submit = async (e) => {
    e.preventDefault();
    setBusy(true);
    setError("");
    try {
      await login(email, password);
      navigate("/admin");
    } catch (err) {
      setError(apiError(err, "تعذر تسجيل الدخول"));
    } finally {
      setBusy(false);
    }
  };

  return (
    <div className="min-h-screen bg-forest flex items-center justify-center px-6" data-testid="admin-login-page">
      <Seo title="تسجيل دخول الإدارة" />
      <div className="w-full max-w-md space-y-8">
        <div className="flex flex-col items-center gap-4">
          <Logo dark />
          <p className="text-ivory/60 text-sm">لوحة التحكم — نموذج تجريبي</p>
        </div>
        <form onSubmit={submit} className="rounded-3xl bg-white p-8 space-y-5 shadow-2xl" data-testid="admin-login-form">
          <div className="flex items-center gap-3 text-forest">
            <Lock className="h-5 w-5 text-gold-dark" aria-hidden="true" />
            <h1 className="font-heading font-bold text-xl">تسجيل دخول المدير</h1>
          </div>
          {error && <p className="rounded-lg bg-destructive/10 text-destructive px-4 py-3 text-sm" data-testid="admin-login-error">{error}</p>}
          <div className="space-y-2">
            <label htmlFor="admin-email" className="text-sm font-heading font-semibold text-forest">البريد الإلكتروني</label>
            <input id="admin-email" type="email" required className="input-lux" dir="ltr" value={email} onChange={(e) => setEmail(e.target.value)} data-testid="admin-email-input" />
          </div>
          <div className="space-y-2">
            <label htmlFor="admin-password" className="text-sm font-heading font-semibold text-forest">كلمة المرور</label>
            <input id="admin-password" type="password" required className="input-lux" dir="ltr" value={password} onChange={(e) => setPassword(e.target.value)} data-testid="admin-password-input" />
          </div>
          <button type="submit" disabled={busy} className="btn-gold w-full disabled:opacity-60" data-testid="admin-login-submit">
            {busy ? "جارٍ الدخول…" : "دخول"}
          </button>
        </form>
        <p className="text-center">
          <Link to="/" className="text-ivory/60 text-sm hover:text-gold transition-colors" data-testid="admin-login-back">العودة للموقع</Link>
        </p>
      </div>
    </div>
  );
}
